import React, { useState, useEffect, Component, FC } from 'react'
import { NavLink, Redirect } from 'react-router-dom'
import Loader from './Loader'
import { connect } from 'react-redux'
import { RootState } from '../../store/reducers'
import { AnimatePresence, motion } from 'framer-motion'
import Navbar from '../landing/layout/Navbar'

const Welcome: FC<{
  children: Component
  isAuthenticated: boolean
}> = ({ children, isAuthenticated }) => {
  document.getElementsByTagName('title')[0].innerHTML = 'Lodies'
  const [open, toggle] = useState(false)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      toggle(false)
    }
    window.scrollTo(0, 0)

    return () => {
      mounted = false
    }
  }, [])

  if (isAuthenticated) {
    return <Redirect to="/dashboard" />
  }

  return (
    <div>
      <Loader />
      <div className="scroll-bar">
        <div className="landing">
          <Navbar open={open} toggle={toggle} />
        </div>
        <div className="uk-hidden@s">
          <AnimatePresence>
            {open && (
              <motion.ul
                initial={{
                  y: `-100vh`,
                }}
                animate={{
                  y: 0,
                }}
                exit={{
                  // y: `100vh`,
                  scale: 0,
                }}
                className="mw-nav"
                style={{ display: 'block' }}
              >
                <li
                  className="active"
                  onClick={() => {
                    toggle(!open)
                  }}
                >
                  <NavLink to="/feed">Home</NavLink>
                </li>
                <li
                  onClick={() => {
                    toggle(!open)
                  }}
                >
                  <NavLink to="/pricing">Pricing</NavLink>
                  {/* <div className="uk-navbar-dropdown">
                    <ul className="uk-nav uk-navbar-dropdown-nav">
                      <li className="uk-active">
                        <NavLink to="#">Active</NavLink>
                      </li>
                      <li>
                        <NavLink to="#">Item</NavLink>
                      </li>
                      <li>
                        <NavLink to="#">Item</NavLink>
                      </li>
                    </ul>
                  </div> */}
                </li>
                <li
                  onClick={() => {
                    toggle(!open)
                  }}
                >
                  <NavLink to="/">Features</NavLink>
                </li>
                <li
                  onClick={() => {
                    toggle(!open)
                  }}
                >
                  <NavLink className="uk-button" to="/login">
                    <span
                      className="goto-app"
                      style={{
                        background: 'rgba(255, 177, 0, 0.19)',
                        borderRadius: '4px',
                      }}
                    >
                      Sign in
                    </span>
                  </NavLink>
                </li>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
        {children && <div id="landing">{children}</div>}
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps)(Welcome)
